import React from 'react';
import { IProductConfig } from 'interfaces/IProductData';
import Br from './Br';
import International from './International';
import { BaseComponent } from 'components/BaseComponent';
import { cartService } from 'services/CartService';
import { IStateBase } from 'components/BaseComponent';
import { enProductType } from 'enums/enProductType';
import QuantityForm from 'components/Cart/Physical/QuantityForm';
import ShippingForm from 'components/Cart/Physical/ShippingForm';
import { paymentService } from 'services/PaymentService';

interface IState extends IStateBase {
  config: IProductConfig;
  personType: string;
}

export default class UserAddressForm extends BaseComponent<IState> {
  componentDidMount() {
    this.observeState({ config: null }, cartService.getConfig());
    this.observeState({ personType: null }, paymentService.getCart().map(c => c.personType));
  }

  render() {
    if (!this.state) {
      return <div />;
    }

    const { config, personType } = this.state;

    return (
      <div>
        {config.productType === enProductType.PHYSICAL && !config.askAddressAfterPayment ? <QuantityForm /> : null}
        {personType === 'E' && config.allowForeignShipping ? <International /> : <Br />}

        {config.productType === enProductType.PHYSICAL && config.askAddressBeforePayment ? <ShippingForm /> : null}
      </div>
    );
  }
}
